module.exports = __webpack_public_path__ + "static/media/gukhwa-jang.794760a1.jpg";